import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const CheckIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox='0 0 12 10'>
        <path fillRule="evenodd" clipRule="evenodd" d="M0.372908 5.71753L3.64646 8.99108C3.89409 9.23856 4.21944 9.36399 4.54663 9.36399C4.84309 9.36399 5.2096 9.25606 5.46422 8.93413L11.5917 2.80663C12.1507 2.31141 12.1086 1.48788 11.6294 1.00885C11.1321 0.511897 10.3264 0.511699 9.82915 1.00899L4.54671 6.29143L2.17311 3.91706C1.67606 3.42028 0.870264 3.41958 0.372771 3.91733C-0.124181 4.41455 -0.124378 5.22024 0.372908 5.71753Z" />
    </SvgIcon>
);
